import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDProgress from 'components/MDProgress';
import Card from '@mui/material/Card';

function ContractDetail({ aaroQueries }) {
    const { orderDetailsQuery, contractQuery, movementsQuery, productMovementsQuery } = aaroQueries;
    // Para formatlama fonksiyonu
    const formatCurrency = (amount, contract) => {
        if (!contract || typeof amount !== 'number') return '₺0,00';
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: contract.DovizKodu || 'TRY',
        }).format(amount);
    };

    // Loading / Error Durumu
    if (contractQuery.isLoading || movementsQuery.isLoading || productMovementsQuery.isLoading) {
        return <MDProgress variant="gradient" />;
    }
    if (contractQuery.isError) {
        return <MDTypography color="error">Hata: {contractQuery.error.message}</MDTypography>;
    }
    if (movementsQuery.isError) {
        return <MDTypography color="error">Hata: {movementsQuery.error.message}</MDTypography>;
    }
    if (productMovementsQuery.isError) {
        return <MDTypography color="error">Hata: {productMovementsQuery.error.message}</MDTypography>;
    }

    // Veriler
    const contract =
        contractQuery.data && Array.isArray(contractQuery.data) && contractQuery.data.length > 0
            ? contractQuery.data[0]
            : {};

    // Sözleşme objesi kontrolü
    if (!contract || !contract.SozlesmeID) {
        return (
            <MDBox>
                <Card>
                    <MDBox p={3}>
                        <MDBox textAlign="center" py={4}>
                            <MDTypography variant="h6" color="text.secondary" mb={2}>
                                Geçersiz Sözleşme Verisi
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary">
                                Sözleşme verisi eksik veya geçersiz.
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </Card>
            </MDBox>
        );
    }

    // İstenmeyen hareket tiplerini hariç tut

    // Sipariş detayları
    const orderDetails = orderDetailsQuery.data || [];
    // Toplam sipariş tutarı
    const toplamSiparisTutari = orderDetails.reduce((sum, detail) => sum + (detail.Tutar || 0), 0);

    // Üretim tutarı
    const uretimTutari = orderDetails.reduce((sum, detail) => {
        const uretimOrani = detail.UretimOrani || 0;
        const detayTutari = detail.Tutar || 0;
        return sum + detayTutari * (uretimOrani / 100);
    }, 0);

    // Sevkiyat tutarı
    const sevkiyatTutari = orderDetails.reduce((sum, detail) => {
        const sevkiyatOrani = detail.SevkiyatOrani || 0;
        const detayTutari = detail.Tutar || 0;
        return sum + detayTutari * (sevkiyatOrani / 100);
    }, 0);

    // "Siparişe göre kesilmesi gereken fatura tutarı"
    // (Örnek: totalCollected - satisFaturasiTutari)

    // Chart colors

    // Chart'ın render edilip edilmeyeceğini kontrol et

    // Üretim ve Sevkiyat İlerleme Oranları (Progress Bars)
    const productionRatio = toplamSiparisTutari ? (uretimTutari / toplamSiparisTutari) * 100 : 0;
    const shipmentRatio = toplamSiparisTutari ? (sevkiyatTutari / toplamSiparisTutari) * 100 : 0;

    // Progress bar color helper function
    const getProgressColor = (value) => {
        if (value < 30) return 'error';
        if (value < 70) return 'warning';
        return 'success';
    };

    return (
        <MDBox>
            {/* Progress Bars in separate card */}
            <Card>
                <MDBox p={3}>
                    <MDBox>
                        <MDBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="caption" fontWeight="medium" color="text">
                                Üretim İlerlemesi
                            </MDTypography>
                            <MDTypography variant="caption" fontWeight="bold" color="text">
                                %{Number(productionRatio).toFixed(1)}
                            </MDTypography>
                        </MDBox>
                        <MDBox mb={1}>
                            <MDProgress
                                value={Number(productionRatio).toFixed(1)}
                                variant="gradient"
                                color={getProgressColor(productionRatio)}
                                height="8px"
                            />
                        </MDBox>
                        <MDTypography variant="caption" color="text.secondary">
                            Üretim: {formatCurrency(uretimTutari, contract)} /{' '}
                            {formatCurrency(toplamSiparisTutari, contract)}
                        </MDTypography>
                    </MDBox>

                    <MDBox mt={3}>
                        <MDBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="caption" fontWeight="medium" color="text">
                                Sevkiyat İlerlemesi
                            </MDTypography>
                            <MDTypography variant="caption" fontWeight="bold" color="text">
                                %{Number(shipmentRatio).toFixed(1)}
                            </MDTypography>
                        </MDBox>
                        <MDBox mb={1}>
                            <MDProgress
                                value={Number(shipmentRatio).toFixed(1)}
                                variant="gradient"
                                color={getProgressColor(shipmentRatio)}
                                height="8px"
                            />
                        </MDBox>
                        <MDTypography variant="caption" color="text.secondary">
                            Sevkiyat: {formatCurrency(sevkiyatTutari, contract)} /{' '}
                            {formatCurrency(toplamSiparisTutari, contract)}
                        </MDTypography>
                    </MDBox>
                </MDBox>
            </Card>
        </MDBox>
    );
}

export default ContractDetail;
